// Strings locales del módulo M1 · Usuarios (docs/08 Ola B). El i18n global de nav ya
// tiene la clave de la sección; aquí viven las cadenas propias de la pantalla.
export const usersI18n = {
  title: "Usuarios",
  description: "Cuentas de los dominios de la instancia, sus roles y su estado.",
  create: "Nuevo usuario",
  search: "Buscar por usuario o nombre",
  filterStatus: "Estado",
  filterAll: "Todos",
  columns: {
    username: "Usuario",
    identifier: "Identificador",
    email: "Email",
    roles: "Roles",
    status: "Estado",
    mfa: "MFA",
  },
  status: {
    active: "Activo",
    locked: "Bloqueado",
    suspended: "Suspendido",
    deleted: "Eliminado",
  },
  mfa: { on: "Activo", off: "—" },
  noRoles: "Sin roles",
  empty: {
    title: "Aún no hay usuarios",
    description: "Crea el primer usuario en un dominio para empezar.",
    action: "Crear el primero",
  },
  createDrawer: {
    title: "Nuevo usuario",
    submit: "Crear usuario",
    domain: "Dominio",
    domainHint: "Dominio al que pertenece el usuario.",
    passwordHint: "Déjala vacía para crear por invitación (enlace de un solo uso).",
  },
  editDrawer: {
    title: "Editar usuario",
    submit: "Guardar cambios",
  },
  fields: {
    username: "Usuario",
    usernameHint: "Minúsculas, números, guion bajo y guion (3-32).",
    name: "Nombre para mostrar",
    email: "Email de contacto (opcional)",
    password: "Contraseña",
    status: "Estado",
  },
  validation: {
    domainRequired: "Selecciona un dominio.",
    usernameRequired: "Escribe el usuario.",
    usernameFormat: "Formato inválido: minúsculas, números, _ y - (3-32).",
    emailFormat: "El email no tiene un formato válido.",
  },
  actions: {
    label: "Acciones del usuario",
    edit: "Editar",
    roles: "Roles",
    lock: "Bloquear",
    unlock: "Desbloquear",
    resetPassword: "Restablecer contraseña",
    delete: "Eliminar",
  },
  delete: {
    title: "Eliminar usuario",
    message: "El usuario quedará eliminado y sus sesiones se revocarán. ¿Continuar?",
    confirm: "Eliminar",
  },
  rolesDrawer: {
    title: "Roles del usuario",
    submit: "Guardar roles",
    empty: "No hay roles disponibles en este dominio.",
    loadError: "No se pudieron cargar los roles.",
  },
  reset: {
    title: "Enlace de restablecimiento",
    description: "Comparte este enlace de un solo uso con el usuario. Caduca pronto.",
    copy: "Copiar enlace",
    copied: "Enlace copiado",
    close: "Cerrar",
  },
} as const
